<template>
<v-card :loading="loading">
  <v-card-actions>

    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
  </v-card-actions>
  <v-divider></v-divider>
  <v-card-text class="text--black">
    <v-row>
      <v-col cols="2" v-for="type in imperativeTypesCount" :key="type.type">
        <v-list-item-content>
          <v-list-item-title class="text-center font-weight-bold">{{type.desc}}</v-list-item-title>
          <v-list-item-subtitle class="text-center">{{type.count}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th><v-text-field v-model="searchByName" label="Customer"></v-text-field></th>
          <th>
            <v-autocomplete
                v-model="queryByImperative"
                label="Imperatives"
                :items="imperativeTypes"
                item-text="desc"
                item-value="id"
                hide-details
                @change="handleChange"
                multiple
                clearable>
                <template v-slot:append-outer>
                  <v-checkbox v-model="withoutImperatives" @change="handleChange()" hide-details label="w/o"></v-checkbox>

                </template>
            </v-autocomplete>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="customer in filteredCustomers" :key="customer.id">
          <td @click="$router.push('/directory_v2/'+customer.id)">{{customer.id}} - {{ customer.primary_name ? customer.primary_name.name : customer.id }}</td>
          <td>
            <v-chip v-for="(imperative, index) in customer.imperatives" :key="`customer_imperative_${customer.id}_${imperative.id}_${index}`" class="ma-2" :color="queryByImperative && queryByImperative.includes(imperative.imperative_type.id) ? 'primary white--text' : ''" text-color="black">
              {{ imperative.imperative_type.desc }}
            </v-chip>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card-text>
</v-card>
</template>

<script>
export default {
  name: "ImperativeTrackingTable",
  props: {},
  data: () => ({
    loading: false,
    imperativeTypes: [],
    lastQueryRan: null,
    withoutImperatives: false,
    customers: [],
    queryByImperative: null,
    searchByName: null,
  }),
  mounted() {
    this.getImperatives();
    this.loadCustomers();
  },
  computed: {
    filteredCustomers(){
      if((!this.withoutImperatives && this.queryByImperative && this.queryByImperative.length > 0) || (!this.withoutImperatives && this.searchByName && this.searchByName.length > 0) ){
        return this.customers.filter((customer) => {
          let found = false;
          if(this.searchByName && this.searchByName.length > 0){
            if(customer.primary_name.name.toLowerCase().includes(this.searchByName.toLowerCase())){
              found = true;
            }
          }
          if(this.queryByImperative && this.queryByImperative.length > 0){
            customer.imperatives.forEach((imperative) => {
              if(this.queryByImperative.includes(imperative.imperative_type.id)){
                if(this.searchByName && this.searchByName.length > 0 && !found){
                  found = false
                }else{
                  found = true;
                }

              }
            })
          }
          return found;
        });
      }
      return this.customers;

    },
    imperativeTypesCount(){
      const countObj = {};
      this.customers.forEach((customer) => {
        customer.imperatives.forEach((imperative) => {
          if(!countObj[imperative.imperative_type.desc]) countObj[imperative.imperative_type.desc] = 0;
          countObj[imperative.imperative_type.desc]++;
        })
      })
      // convert countObj to alphabetical order array
      const countArray = Object.keys(countObj).map((key) => {
        return {
          desc: key,
          count: countObj[key],
        }
      })
      countArray.sort((a, b) => {
        return a.desc > b.desc ? 1 : -1;
      })
      return countArray;
    }
  },
  methods: {
    async getImperatives() {
      let customer_id = this.$route.params.customer_id;
      let imperatives = await this.$store.$db().model('imperativeTypes').api().fetch({}, "", null, false);
      this.imperativeTypes = imperatives.response.data;
    },
    handleChange(){
      if(!this.queryByImperative || (this.queryByImperative.length === 0 && this.withoutImperatives)) return;
      if(!this.withoutImperatives){
        this.loadCustomers();
      }
      if(this.queryByImperative && this.queryByImperative.length > 0 && this.withoutImperatives){
        this.loadCustomersWithoutSpecificImperatives();
      }
    },
    async loadCustomers(){
      this.loading = true;
      let customerQuery = await this.$store.$db().model('customers').api().fetch({
        select: 'id',
        with: 'primaryName,imperatives',
        has: 'imperatives',
      }, "", null, false);
      customerQuery.response.data.forEach((customer) => {
        customer.imperatives.sort((a, b) => {
          return a.imperative_type.desc > b.imperative_type.desc ? 1 : -1;
        });
      });
      customerQuery.response.data.sort((a, b) => {
        return a.primary_name.name > b.primary_name.name ? 1 : -1;
      });
      this.customers = customerQuery.response.data;
      this.loading = false;
    },
    async loadCustomersWithoutSpecificImperatives(){
      this.loading = true;
      if(!this.queryByImperative || this.queryByImperative.length === 0) return;
      this.lastQueryRan = 'loadCustomersWithoutSpecificImperatives'
      let customerQuery = await this.$store.$db().model('customers').api().fetch({
        select: 'id',
        with: 'primaryName,imperatives',
        has: 'primaryName',
        where_in: {
          key: 'id',
          values: [
            '617',
            '1521',
            '1528',
            '652',
            '51',
            '951',
            '70',
            '1437',
            '1531',
            '858',
            '826',
            '431',
            '1509',
            '491',
            '299',
            '309',
            '1317',
            '436',
            '1517',
            '292',
            '1397',
            '663',
            '770',
            '22',
            '1493',
            '932',
            '1408',
            '1175',
            '493',
            '1064',
            '780',
            '1433',
            '1204',
            '73',
            '577',
            '1252',
            '420',
            '1438',
            '113',
            '125',
            '1426',
            '561',
            '1485',
            '1467',
            '1431',
            '1322',
            '658',
            '1031',
            '1444',
            '196',
            '578',
            '703',
            '1422',
            '1415',
            '710',
            '349',
            '1016',
            '1519',
            '57',
            '61',
            '1313',
            '1367',
            '160',
            '1510',
            '1416',
            '1501',
            '1495',
            '1463',
            '1270',
            '1436',
            '1516',
            '1461',
            '1429',
            '1543',
            '1409',
            '546',
            '1427',
            '1455',
            '1312',
            '1484',
            '1518',
            '303',
            '201',
            '10',
            '1508',
            '1387',
            '402',
            '785',
            '1406',
            '963',
            '1542',
            '822',
            '1487',
            '1401',
            '1391',
            '1007',
            '596',
            '776',
            '1383',
            '1199',
            '14',
            '1432',
            '13',
            '1513',
            '1505',
            '414',
            '1137',
            '1323',
            '600',
            '1511',
            '1309',
            '1522',
            '1216',
            '428',
            '896',
            '1381',
            '1324',
            '771',
            '827',
            '777',
            '1449',
            '377',
            '1154',
            '1012',
            '1435',
            '1325',
            '922',
            '1402',
            '1451',
            '787',
            '1399',
            '1099',
            '250',
            '432',
            '186',
            '986',
            '611',
            '1457',
            '47',
            '886',
            '750',
            '865',
            '1341',
            '1417',
            '1405',
            '1507',
            '110',
            '145',
            '1392',
            '557',
            '795',
            '228',
            '1474',
            '814',
            '1310',
            '1439',
            '708',
            '294',
            '68',
            '684',
            '1112',
            '1315',
            '1491',
            '146',
            '1453',
            '1395',
            '701',
            '1208',
            '1092',
            '1351',
            '132',
            '378',
            '1506',
            '1414',
            '1333',
            '1386',
            '916',
            '1197',
            '1523',
            '473',
            '1059',
            '1471',
            '323',
            '114',
            '1458',
            '97',
            '1504',
            '399',
            '729',
            '268',
            '782',
            '589',
            '1514',
            '1535',
            '615',
            '1482',
            '1488',
            '1445',
            '1340',
            '1492',
            '527',
            '1462',
            '1456',
            '590',
            '1329',
            '1447',
            '119',
            '1398',
            '659',
            '153',
            '676',
            '147',
            '214',
            '1534',
            '9',
            '1481',
            '1110',
            '419',
            '1490',
            '741',
            '1336',
            '565',
            '412',
            '1473',
            '1470',
            '1170',
            '1532',
            '85',
            '1440',
            '1260',
            '1527',
            '1434',
            '77',
            '259',
            '1448',
            '1520',
            '409',
            '840',
            '521',
            '936',
            '37',
            '212',
            '310',
            '720',
            '1469',
            '997',
            '388',
            '834',
            '1280',
            '1295',
            '1164',
            '984',
            '1298',
            '296',
            '1335',
            '1443',
            '34',
            '1524',
            '1411',
            '1393',
            '972',
            '63',
            '1326',
            '90',
            '673',
            '1377',
            '1127',
            '1496',
            '1423',
            '174',
            '1446',
            '1375',
            '134',
            '1419',
            '1538',
            '1051',
            '1477',
            '36',
            '848',
            '1512',
            '752',
            '167',
            '498',
            '158',
            '688',
            '1185',
            '460',
            '300',
            '533',
            '662',
            '1076',
            '851',
            '1441',
            '805',
            '1410',
            '1215',
            '655',
            '439',
            '1442',
            '1210',
            '704',
            '53',
            '1327',
            '1476',
            '275',
            '1412',
            '880',
            '1240',
            '150',
            '354',
            '1459',
            '479',
            '137',
            '1537',
            '1498',
            '1499',
            '141',
            '1539',
            '1355',
            '1454',
            '1515',
            '1503',
            '211',
            '1282',
            '1420',
            '332',
            '654',
            '580',
            '530',
            '696',
            '380',
            '1421',
            '912',
            '1502',
            '55',
            '270',
            '1465',
            '1478',
            '486',
          ]
        },
        where_doesnt_have: this.queryByImperative.map(imp => {
          return {
            relation: 'imperatives',
            where: [
              {key: 'imperative_type_id', value: imp}
            ]
          }
        })
      }, "", null, false);
      customerQuery.response.data.forEach((customer) => {
        customer.imperatives.sort((a, b) => {
          return a.imperative_type.desc > b.imperative_type.desc ? 1 : -1;
        });
      });
      customerQuery.response.data.sort((a, b) => {
        if (!a.primary_name || !b.primary_name){
          return 0;
        }
        return a.primary_name && a.primary_name.name > b.primary_name.name ? 1 : -1;
      });
      // this.customers = customerQuery.response.data;
      this.$set(this, 'customers', customerQuery.response.data);
      console.log(this.customers.map(customer => customer.primary_name.name));
      this.loading = false;
    }
  }
}
</script>

<style scoped>

</style>
